import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useQuery as useRetailerIdvStatusQuery } from "@faire/web-api--source/api/retailer-idv-status/retailerToken/get-hooks";
import { IGetRetailerIdvStatusResponse } from "@faire/web-api--source/indigofair/data/IGetRetailerIdvStatusResponse";
var IdvStatus = IGetRetailerIdvStatusResponse.IdvStatus;
export var useIdvStatusQuery = function() {
    var _useRetailer = useRetailer(), retailer = _useRetailer.retailer, retailerToken = _useRetailer.retailerToken;
    var identityConfirmed = retailer === null || retailer === void 0 ? void 0 : retailer.identity_confirmed;
    var _useRetailerIdvStatusQuery = useRetailerIdvStatusQuery(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", {
        enabled: !!retailerToken && !identityConfirmed,
        staleTime: STALE_TIME,
        gcTime: STALE_TIME,
        refetchOnMount: false,
        initialData: identityConfirmed ? IGetRetailerIdvStatusResponse.build({
            idv_status: IdvStatus.IDV_REQUEST_RESPONDED
        }) : undefined
    }), data = _useRetailerIdvStatusQuery.data, result = _object_without_properties(_useRetailerIdvStatusQuery, [
        "data"
    ]);
    return _object_spread({
        data: data !== null && data !== void 0 ? data : IGetRetailerIdvStatusResponse.build({
            idv_status: IdvStatus.IDV_STATUS_UNKNOWN
        })
    }, result);
};
var STALE_TIME = 1000 * 60 * 5;
